<template>
  <AppErrorState
    title="Whoops!"
    subtitle="Seems like something went wrong."
    :status-code="error.statusCode"
    :description="error.statusMessage"
  >
    <template #actions>
      <AppButton
        label="Refresh"
        @click="handleStartAgain"
      />
      <AppButton
        v-if="authStore.isAuthenticated"
        label="Sign Out"
        variant="outline"
        @click="handleSignOut"
      />
    </template>
  </AppErrorState>
</template>

<script setup lang="ts">
import { type NuxtError } from '#app'
import { useAuthStore } from '~/stores/auth'

defineProps({
  error: {
    type: Object as PropType<NuxtError>,
    required: true,
  },
})

const authStore = useAuthStore()

function handleSignOut() {
  clearError()
  authStore.signOut()
}

function handleStartAgain() {
  clearError()
  window.location.reload()
}
</script>
